import React from 'react';
import { ScheduleView } from './ScheduleView';
import { Game } from '../types';

interface ClubScheduleViewProps {
  filter?: 'upcoming' | 'finished';
  onGameSelect?: (game: Game | null) => void;
}

export const ClubScheduleView: React.FC<ClubScheduleViewProps> = ({ filter, onGameSelect }) => {
  return <ScheduleView isClubSchedule={true} filter={filter} onGameSelect={onGameSelect} />;
};
